import Modal from '@mui/material/Modal'
import LinearProgress from '@mui/material/LinearProgress'
import Typography from '@mui/material/Typography'
import clsx from 'clsx'
import Root, { classes } from './ProgressModalStyles'

const ProgressModal = ({ title, open }) => (
  <Modal
    aria-labelledby="progress-modal-dialog"
    aria-describedby="progress-dialog"
    open={open}
  >
    <Root className={clsx(classes.paper, classes.modal)}>
      <LinearProgress />
      <Typography variant="subtitle" className={classes.message}>
        {title}
      </Typography>
    </Root>
  </Modal>
)

export default ProgressModal
